import { Injectable } from '@angular/core';
import { map } from "rxjs/operators";

import { AuthenticationService } from './authentication.service';

@Injectable()
export class UserService{

    private storageName:string ='deliveryRateUserToken';
    // private defaultLab:string = ""

    constructor(private AuthService: AuthenticationService){}

    // public getDefaultLab(){
    //     return this.getUserSetting("Default Lab");
    // }

    // loginUser(userName:string, password:string){
    //     return this.AuthService.login(userName,password).pipe(map(user =>{
    //         this.removeUser()
    //         this.setCurrentUser(user);
    //         return true;
    //     }));
    // }

    public startUserVerification(username:string){
        this.removeUser()
        return new Promise((resolve)=>{
            this.AuthService.startVerification(username).then((data)=>{
                resolve(data);
            }).catch((err)=>{
                console.log(err);
                resolve("err")
            })
        })
    }

    public verify(state:string, code:string){
        return new Promise((resolve,reject) => {
            this.AuthService.verify(state, code).then((data)=>{
                this.removeUser();
                this.setCurrentUser(data);
                resolve(data)
            }).catch((err)=>{
                reject(err)
            })
        })
    }

    logoutUser(){
        // let username = this.getUserId();// === null ? "" : this.getUserId() 
        // this.AuthService.logout(this.getUserToken(),username === null ? "" : username);
        this.removeUser();
    }

    getByAccessType(type:string):any[]|null{
        let nodes = [];

        let profile = this.getLocatlStorageObject();

        if(profile !== null && typeof profile !== "undefined" && profile.access !== null && typeof profile.access !== "undefined"){
            for(let i=0; i<profile.access.length; i++){
                if(profile.access[i].type === type){
                    nodes.push(profile.access[i]);
                }
            }
        }

        if(nodes.length>0){
            return nodes;
        }else{
            return null
        }
    }

    getByNodeName(name:string, type:string):object|null{
        let node = {}
        let roles = this.getLocatlStorageObject();

        if(roles !== null && typeof roles !== "undefined" && roles.access !== null && typeof roles.access !== "undefined"){
            for(let i=0; i<roles.length; i++){
                if(roles[i].type === type && roles[i].name === name.toLowerCase()){
                    return roles[i];
                }
            }
        }
        
        return null;
    }

    checkStatus(){
        let token = this.getUserToken();
        let username = this.getUserName();
        return this.AuthService.status(username, token);
    }

    // getNodeIdByPagePath(path:string):number{
    //     let roles = this.getLocatlStorageObject();
    //     if(roles !== null && typeof roles !== "undefined" && roles.access !== null && typeof roles.access !== "undefined"){
    //         for(let i=0; i<roles.length; i++){
    //             if(roles[i].hierarchyName === 'Page' && roles[i].nodeProperties.length>0 ){
    //                 for(let x=0; x<roles[i].nodeProperties.length; x++){
    //                     if(roles[i].nodeProperties[x].propertyName === "Path" && roles[i].nodeProperties[x].propertyValue === path ){
    //                         return roles[i].nodeId;
    //                     }
    //                 }
    //             }
    //         }
    //     }
        
    //     return -1;
    // }

    // getNodeNameByPagePath(path:string):string{
    //     let roles = this.getLocatlStorageObject();
    //     if(roles !== null && typeof roles !== "undefined" && roles.access !== null && typeof roles.access !== "undefined"){
    //         for(let i=0; i<roles.length; i++){
    //             if(roles[i].type === 'Page' && roles[i].nodeProperties.length>0 ){
    //                 for(let x=0; x<roles[i].nodeProperties.length; x++){
    //                     if(roles[i].nodeProperties[x].propertyName === "Path" && roles[i].nodeProperties[x].propertyValue === path ){
    //                         return roles[i].name;
    //                     }
    //                 }
    //             }
    //         }
    //     }
    //     return "";
    // }

    // userEvent(nodeName:string, detail:string, description:string){
    //     let token = this.getUserToken();
    //     return this.AuthService.userEvent(token, detail, description, nodeName);
    // }

    // getUserDefualtPage():string{
    //     try{
    //         return this.getUserSettingsValue("DefaultPage");
    //         //return JSON.parse(localStorage.getItem(this.storageName)).pageLoad;
    //     }catch{
    //         this.removeUser();
    //         return '';
    //     }
    // }

    getUserName():string{
        try{
            let value = localStorage.getItem(this.storageName)
            if(value != null){
                return JSON.parse(value).username;
            }else{
                this.removeUser();
            return '';
            }
            
        }catch{
            this.removeUser();
            return '';
        }
    }

    getUserId():string{
        return this.getUserName();
        // try{
        //     let value = localStorage.getItem(this.storageName)
        //     if(value != null){
        //         return JSON.parse(value).usercode;
        //     }else{
        //         this.removeUser();
        //         return '';
        //     }
            
        // }catch{
        //     this.removeUser();
        //     return '';
        // }
    }

    // public getUserSetting(setting:string):string|null{
    //     return this.getUserSettingsValue(setting);
    // }

    private setCurrentUser(user:any){
        localStorage.setItem(this.storageName, JSON.stringify(user));
    }

    private removeUser(){
        localStorage.removeItem(this.storageName);
    }

    public getUserToken():string{
        try{
            let value = localStorage.getItem(this.storageName)
            if(value != null){
                return JSON.parse(value).token;
            }else{
                this.removeUser();
            return '';
            }
            
        }catch{
            this.removeUser();
            return '';
        }
    }
    private getLocatlStorageObject(){
        let value = localStorage.getItem(this.storageName);
        if(value != null){
            return JSON.parse(value);
        }
        return null;
        
    }

    // private getUserSettingsValue(setting:string){
    //     let value = localStorage.getItem(this.storageName);
    //     var settings = JSON.parse(value != null ? value : '').userSettings;
    //     for(let i=0; i<settings.length; i++){
    //         if(settings[i].setting === setting){
    //             return settings[i].value;
    //         }
    //     }
    //     return "";
    // }

    // private getUserPages(){
    //     var roles = this.getLocatlStorageObject().access;
    //     var page ={name:"", path:""};
    //     var Pages = [];

    //     for(let i=0; i<roles.length; i++){
    //         page = {name:"", path:""};
    //         if(roles[i].type === 'Page' && roles[i].nodeProperties.length>0 ){
    //             for(let x=0; x<roles[i].nodeProperties.length; x++){
    //                 if(roles[i].nodeProperties[x].propertyName === "DisplayName"){
    //                     page.name = roles[i].nodeProperties[x].propertyValue;
    //                 }
    //                 if(roles[i].nodeProperties[x].propertyName === "Path"){
    //                     page.path = roles[i].nodeProperties[x].propertyValue;
    //                 }
    //             }
    //         }
    //         if(page.name !== "" && page.path !== ""){
    //             Pages.push(page);
    //         }
    //     }
    //     return Pages;
    // }
}